import { authConfig, tenantConfig } from '../config/auth.config';
import { AuthError, UserAgentApplication } from 'msal';

class AuthController {
  private readonly clientApplication: UserAgentApplication;

  public constructor() {
    this.clientApplication = new UserAgentApplication(authConfig);

    // Handling redirect callback
    // TODO: Commenting this until FSC finishes setting up AD on their end
    // this.clientApplication.handleRedirectCallback((error, response) => this.handleRedirectCallback(error, response));
  }

  /**
   * Handle redirect response or error
   * @param error The error from the auth redirect.
   * @param response The response from the auth redirect
   */
  // TODO: Commenting this until FSC finishes setting up AD on their end
  // private handleRedirectCallback = (error: AuthError, response?: AuthResponse) => {
  //   console.log('auth redirect callback');
  // };

  /**
   * Method to login to the Azure AD B2C. By using the acquireTokenSilent, we attempt to silently make a request
   * to the Azure AD B2C service using the session token stored in the browser's storage.
   */
  public async login() {
    const accessTokenRequest = { scopes: tenantConfig.scopes };
    this.clientApplication
      .acquireTokenSilent(accessTokenRequest)
      .then(() => {})
      .catch((error: AuthError) => {
        // Depending on the error, we
        if (error.errorCode === 'user_login_error') {
          this.clientApplication.loginRedirect();
        } else if (error.errorCode === 'consent_required' || error.errorCode === 'interaction_required') {
          // TODO: Commenting this until FSC finishes setting up AD on their end
          // this.clientApplication.acquireTokenRedirect(accessTokenRequest);
        }
      });
  }

  logout() {
    this.clientApplication.logout();
  }
}

export default new AuthController();
